export const companyDetails = 'company-details';
export const businessDetails = 'business-details';
export const confirmAddress = 'confirm-address';
export const directorDetails = 'director-details';
export const personalDetails = 'personal-details';
export const personalSelfie = 'personal-selfie';
export const residentialAddress = 'residential-address';
export const uploadDocuments = 'upload-documents';
export const bankDetails = 'bank-details';
